/** The impersonation confirm's title. Matches the floating impersonate button's confirm. */
export const IMPERSONATION_CONFIRM_TITLE = "Confirm impersonation?";

/** The error toast when the impersonation session could not be started. The raw error is only logged. */
export const IMPERSONATION_FAILED_MESSAGE = "Could not start impersonation.";

/** The toast when a staff member lands on "View as user" for their own user. */
export const IMPERSONATE_SELF_MESSAGE = "You're already signed in as yourself.";

/** The toast when the user has no email, so there is no login to sign in as. */
export const IMPERSONATE_NO_EMAIL_MESSAGE = "This user has no email to sign in with.";

/** The toast when the user never signed in (an invite placeholder), so there is no account to view as. */
export const IMPERSONATE_PENDING_MESSAGE = "This user hasn't signed up yet.";

/**
 * The impersonation confirm's message: the floating impersonate button's copy, plus the email so
 * two people with the same name are told apart.
 *
 * @param name - The person's display name (full name, else email).
 * @param email - The login the impersonation signs into; left out when empty or the same as `name`.
 * @returns The message.
 */
export function impersonationConfirmMessage(name: string, email: string): string {
  const who = email === "" || email === name ? name : `${name} (${email})`;
  return `You will be logged out of your current account to impersonate ${who}.`;
}

/** Row cap on the impersonate picker's results: the newest users for an empty search, else the newest matches. */
export const IMPERSONATE_USER_RESULT_LIMIT = 50;

/** How long the picker waits after the last keystroke before searching. */
export const IMPERSONATE_SEARCH_DEBOUNCE_MS = 200;
